import { HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { User } from 'oidc-client-ts';
import { API_URL, COGNITO_AUTHORITY, COGNITO_CLIENT_ID } from '../../constants';

const getToken = () => {
  const oidcStorage = sessionStorage.getItem(
    `oidc.user:${COGNITO_AUTHORITY}:${COGNITO_CLIENT_ID}`,
  );
  if (!oidcStorage) {
    return null;
  }

  const user = User.fromStorageString(oidcStorage);
  return user?.access_token;
};

const generateLink = () => {
  const httpConnectionLink = new HttpLink({
    uri: API_URL,
  });

  const authLink = setContext((_, previousContext) => {
    const token = getToken();

    return {
      ...previousContext,
      headers: {
        ...previousContext.headers,
        ...(token
          ? {
              authorization: `Bearer ${token}`,
            }
          : {}),
      },
    };
  });

  const errorLink = onError(
    ({ graphQLErrors, networkError, operation, forward }) => {
      if (!graphQLErrors) return;
    },
  );

  return from([errorLink, authLink, httpConnectionLink]);
};

export default generateLink;
